<template>
  <div class="Published-container">
    <DataTable :type="Role" :title="Title" />
  </div>
</template>

<script>
import DataTable from "@/components/DataTable.vue";
export default {
  components: {
    DataTable,
  },
  created() {
    console.log(this.$store.state.type,'this.Role');
    
  },
  computed: {
    Role() {
      if (this.$store.state.type === 1 || this.$store.state.type === 2) {
        return "My";
      }  else if (this.$store.state.type === 3) {
        return 'rogerThat'
      }
    },
    Title(){
      if (this.$store.state.type === 1) {
        return "我发布的需求";
      } else if (this.$store.state.type === 2) {
        return "我发布的需求";
      } else if (this.$store.state.type === 3) {
        return '原始需求列表'
      } 
    }
  },
  data() {
    return {};
  },
};
</script>

<style scoped></style>
